var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0a.643.643 0 00-.643.643v1.286h1.286V.643A.643.643 0 004.5 0zM13.5 0a.643.643 0 00-.643.643v1.286h1.286V.643A.643.643 0 0013.5 0zM16.071 1.929h-1.928V4.5a.643.643 0 01-1.286 0V1.929H5.143V4.5a.643.643 0 01-1.286 0V1.929H1.929A1.929 1.929 0 000 3.858v12.214a1.929 1.929 0 001.929 1.929h14.142A1.929 1.929 0 0018 16.072V3.858a1.929 1.929 0 00-1.929-1.929zm.643 14.143a.643.643 0 01-.643.643H1.929a.643.643 0 01-.643-.643V7.715h15.428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.312 9.188a.643.643 0 00-.909 0l-4.688 4.688-2.118-2.114a.643.643 0 00-.909.91l2.571 2.571a.643.643 0 00.909 0l5.143-5.143a.643.643 0 00.001-.912z"
  }))));
}
export default __webpack_public_path__ + "media/icons/icn_calendar-2caabc4b.svg";
export { SvgIcnCalendar as ReactComponent };